import * as api from 'api/users';

export const fetchUsers = params => ({
  type: 'FETCH_USERS',
  payload: api.fetchUsers(params),
});

export const fetchChildUsers = params => ({
  type: 'FETCH_CHILDREN',
  payload: api.fetchChildUsers(params),
});

export const fetchNonThirdParty = params => ({
  type: 'FETCH_NON_THIRD_PARTY',
  payload: api.fetchUsers(params),
});

export const login = (email, password) => ({
  type: 'LOGIN',
  payload: api.login(email, password),
});

export const shibLogin = () => ({
  type: 'SHIB_LOGIN',
  payload: api.shibLogin(),
});

export const logout = () => ({
  type: 'LOGOUT',
  payload: '',
});

export const fetchAppUser = token => ({
  type: 'FETCH_APP_USER',
  payload: api.fetchAppUser(token),
});

export const refreshToken = token => ({
  type: 'REFRESH_TOKEN',
  payload: api.fetchAppUser(token),
});
